import React from "react";
import { Helmet } from "react-helmet-async";
import CpntHeaderFO from "../CpntHeaderFO";
import CpntFooterFO from "../CpntFooterFO";
import { Outlet, useLocation } from "react-router-dom";
//import img_expertiseherocover from "../../images/expertise-hero-cover.svg"
import img_expertiseherocover from "../../images/editeurspros_cover.svg"

import useGoogleAnalytics from "../hooks/analytics_hook";

const FoLayoutDeconnecte: React.FC = () => {

  const location = useLocation();
  
  useGoogleAnalytics();
  
  return (
    <div >
      <Helmet>
        <meta charSet="utf-8" />
        <title>{process.env.REACT_APP_WEBSITE_TITLE}</title>
        {location && (
          <link
            rel="canonical"
            href={window.location.pathname + location.pathname}
          />
        )}
        <meta
          name="description"
          content="Services aux éditeurs"
        />
      </Helmet>
      <CpntHeaderFO />
        <div className="App-body-FO-Deconnecte">
          <div className="container-fluid text-center mb-5">
            <div className="col-xl-8 offset-xl-2 col-lg-2">
            <img src={img_expertiseherocover} alt="" className="expertiseherocover " />  {/* d-block d-xl-none */}
            </div>
            <Outlet />
          </div>
        </div>
      <CpntFooterFO />
      </div>
  );
};

export default FoLayoutDeconnecte;
